/**
 * Chromium reports these via window.onerror; they are layout-notification
 * quirks, not application failures.
 */
const BENIGN_FRONTEND_ERROR_SUBSTRINGS = [
  'ResizeObserver loop completed with undelivered notifications',
  'ResizeObserver loop limit exceeded',
]

export function isBenignFrontendError(message: unknown): boolean {
  const m = String(message ?? '').trim().toLowerCase()
  if (!m) return false
  return BENIGN_FRONTEND_ERROR_SUBSTRINGS.some((s) => m.includes(s.toLowerCase()))
}
